import { Grid, Typography } from '@mui/material';
import { Show } from '@side/pantry';
import { useQuickLinksSection } from '../../hooks/useQuickLinksSection';
import { SectionContainer } from '../SectionContainer';
import { LoadingSkeleton, QuickLinkButton } from './components';

export function QuickLinks() {
  const { quickLinks, loading } = useQuickLinksSection();

  return (
    <SectionContainer
      data-testid="txm-home-quick-links-section"
      sx={{
        backgroundColor: 'background.default',
        pt: 5,
        pb: 6,
      }}
    >
      <Typography
        variant="h4"
        component="h2"
        sx={{ color: 'other.spaceCadet', pb: 1 }}
      >
        Quick Links
      </Typography>
      <Grid container columns={{ xs: 2, md: 5 }}>
        <Show
          when={!loading}
          fallback={[...new Array(5).keys()].map((i) => (
            <LoadingSkeleton key={i} />
          ))}
        >
          {quickLinks.map((quickLink) => (
            <QuickLinkButton key={quickLink.title} {...quickLink} />
          ))}
        </Show>
      </Grid>
    </SectionContainer>
  );
}
